export default __webpack_public_path__ + "static/media/code-icon.a732e1ef.svg";